import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import Modal from './';

const SelectSuccessorModal = ({
  isOpen,
  modalTitle,
  title,
  description,
  onClose,
  onConfirm,
  children,
  dropdownDescription,
  isItemSelected,
  validationMessage,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      placeholder={modalTitle}
      description={description}
      primaryButtonDisabled={!isItemSelected}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <>
        <div className="select-wrapper">
          <p className="styled-menu-label">{t('selectSuccessorModal.chooseSuccessor')}</p>
          <span>{children}</span>
        </div>
        {!isItemSelected && <p className="select-message red">{validationMessage}</p>}
        {dropdownDescription && <p className="static-message">{dropdownDescription}</p>}
      </>
    </Modal>
  );
};

export default SelectSuccessorModal;
